"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.voice-agent.disabled': '语音代理功能在您当前的计划中不可用。',
};
